<template>
    <div class="booking-stats">
        <v-row>
            <v-col>
                <v-switch hide-details label="Kun genbookede" v-model="$store.state.meetings.onlyRebooking" />
            </v-col>
            <v-col>
                <v-autocomplete solo prefix="Kampagne: " v-model="$store.state.meetings.bookingCampaign" :items="$store.getters['meetings/bookingCampaigns']" />
            </v-col>
            <v-col v-if="access !== 'booking'">
                <v-autocomplete solo prefix="Booker: " v-model="$store.state.meetings.bookingAgentOrgCode" :items="$store.getters['meetings/bookingAgents']" />
            </v-col>
            <v-col v-if="access !== 'booking'">
                <v-autocomplete solo prefix="Team: " v-model="$store.state.meetings.team" :items="$store.getters['meetings/teams']" />
            </v-col>
            <v-col v-if="access !== 'booking'">
                <v-autocomplete solo prefix="Agentur: " v-model="$store.state.meetings.salesAgent" :items="$store.getters['meetings/salesAgents']" />
            </v-col>
            <v-col>
                <v-autocomplete solo prefix="Mødetype: " v-model="$store.state.meetings.type" :items="typeSelect" />
            </v-col>
            <v-col cols="4">
                <range-picker :solo="true" storeName="meetings" rangeName="statsRange" periodName="statsPeriod" :presets="$store.state.meetings.meetingDatePresets" />
            </v-col>
        </v-row>
        <router-view />
    </div>
</template>

<script>
import RangePicker from '@/components/rangePicker.vue'

export default {
    components: {
        RangePicker
    },
    computed: {
        access () {
            return this.$store.state.main.access
        }
    },
    data () {
        return {
            typeSelect: [
                {
                    text: 'Alle',
                    value: null
                },
                {
                    text: 'Tele',
                    value: 'tele'
                },
                {
                    text: 'Fysisk',
                    value: 'physical'
                },
                {
                    text: 'Online',
                    value: 'online'
                }
            ]
        }
    },
    created () {
        if (this.$store.state.main.access === 'booking') this.$store.state.meetings.bookingAgentOrgCode = this.$store.state.main.orgCode
    }
}
</script>

<style lang="scss">
.booking-stats .v-input--selection-controls {
    margin-top: 10px !important;
}
</style>